export default {
    'signin.title': 'Sign in',
    'signin.organisation': 'Organisation',
    'signin.username': 'Username or email',
    'signin.password': 'Password',
    'signin.code': 'Authenticator code',
    'signin.submit': 'Sign in',
    'signin.failed': 'That username and password do not match',
    'signin.email': 'Email',
    'signin.app_name': 'Hospital Information System',
    'signin.organisation_hint': 'Your subdomain, e.g. shifa — a hospital, lab or pharmacy',
    'signin.enter_code': 'Enter the six-digit code from your authenticator app.',
    'signin.subtitle.tenant': 'Sign in to your hospital, lab or pharmacy',
    'signin.subtitle.client': 'Account managers — your hospitals, their tickets and renewals',
    'signin.subtitle.platform': 'Platform staff (owner: use the Owner console)',
    'signin.switch.tenant': 'Sign in to a hospital instead',
    'signin.switch.client': 'Account manager sign-in',
    'signin.switch.platform': 'Platform staff sign-in',
    'signin.facility.hospital': 'Sign in to your hospital',
    'signin.facility.lab': 'Sign in to your laboratory',
    'signin.facility.pharmacy': 'Sign in to your pharmacy',
    'signin.directory_prompt': 'Looking for a hospital, lab or pharmacy?',
    'signin.directory_link': 'Search the public directory',
    'password.change_title': 'Choose a new password',
    'password.current': 'Current password',
    'password.new': 'New password',
    'password.confirm': 'Confirm new password',
    'password.save': 'Change password',
    'two_factor.setup_title': 'Set up two-factor sign-in',
    'two_factor.scan': 'Scan this code with your authenticator app, then enter the six-digit code it shows',
    'security.title': 'Security',
    'security.description': 'Your password and two-factor sign-in.',
    'security.password_title': 'Password',
    'security.password_hint': 'Changing it signs you out everywhere, this device included.',
    'security.password_changed': 'Password changed',
    'security.sign_in_again': 'Sign in again with the new one.',
    'security.rule_length': 'At least 10 characters',
    'security.rule_upper': 'An uppercase letter (A–Z)',
    'security.rule_lower': 'A lowercase letter (a–z)',
    'security.rule_digit': 'A digit (0–9)',
    'security.rule_symbol': 'A symbol (! @ # $ % …)',
    'security.passwords_differ': 'The two passwords differ',
    'security.two_factor_title': 'Two-factor sign-in',
    'security.two_factor_on': 'On',
    'security.two_factor_off': 'Off',
    'security.two_factor_on_hint': 'Each sign-in asks for a six-digit code from your authenticator app.',
    'security.two_factor_off_hint': 'Only your password protects this account. Turn it on to ask for a code from your authenticator app as well.',
    'security.two_factor_mandated': 'Your hospital requires two-factor sign-in for your role, so it cannot be turned off here. A Super Admin can change this in Settings.',
    'security.turn_on': 'Turn on',
    'security.turn_off': 'Turn off',
    'security.re_enrol': 'Re-enrol',
    'security.enrol_title': 'Set up your authenticator',
    'security.enrol_body': 'Add this key to Google Authenticator, Authy or 1Password, then enter the code it shows.',
    'security.secret_key': 'Secret key',
    'security.open_in_app': 'Open in authenticator app',
    'security.account': 'Account',
    'security.code': 'Six-digit code',
    'security.current_code': 'Code from your current authenticator',
    'security.confirm': 'Confirm',
    'security.cancel': 'Cancel',
    'security.enrolled': 'Two-factor sign-in is on',
    'security.keep_authenticator': 'Keep your authenticator to hand — you will need it each time.',
    'security.turn_off_title': 'Turn off two-factor sign-in',
    'security.turn_off_body': 'Confirm with your password and the current code from your authenticator.',
    'security.turned_off': 'Two-factor sign-in is off',
    'security.re_enrol_hint': 'The old authenticator stops working once the new one is confirmed.',
    'security.change_phone': 'Move to a new phone',
    'security.change_phone_hint': 'Use this when you get a new phone or lose the authenticator. The old one stops working once the new one is confirmed.',
};
//# sourceMappingURL=auth.js.map